import { atom } from "recoil";
import { LastLoginAccountHint } from "utils/accountHint";

const STORAGE_KEY = "last_login_account_hint";

// 네이티브가 OneLink deep_link_sub2 로 전달한 "웹퍼널에 마지막으로 로그인한
// 계정"의 해시. 앱에 다른 계정으로 로그인된 경우를 감지하는 데 쓴다
// (AccountMismatchGuard). localStorage 영속: 이벤트 도착 시점에 로그아웃
// 상태였다가 나중에 잘못된 계정으로 로그인하는 경우에도 비교할 수 있게 한다.
// 해시가 일치(정상 계정)하면 제거.
export const lastLoginAccountHintAtom = atom<LastLoginAccountHint | undefined>({
  key: "lastLoginAccountHint",
  default: undefined,
  effects: [
    ({ setSelf, onSet }) => {
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
          const parsed = JSON.parse(saved);
          // receivedAt 이 숫자가 아니면 TTL 판정이 NaN 으로 영구 통과하므로
          // 형식이 온전한 저장분만 복원한다
          if (
            parsed &&
            typeof parsed.hash === "string" &&
            typeof parsed.clickId === "string" &&
            typeof parsed.receivedAt === "number"
          ) {
            setSelf(parsed);
          }
        }
      } catch {}

      onSet((newValue, _, isReset) => {
        isReset || newValue == null
          ? localStorage.removeItem(STORAGE_KEY)
          : localStorage.setItem(STORAGE_KEY, JSON.stringify(newValue));
      });
    },
  ],
});
